//region block: pre-declaration
//endregion
function withCause(_this__u8e3s4, cause) {
  return _this__u8e3s4;
}
//region block: exports
export {
  withCause as withCausej2y4rjnimuh7,
};
//endregion

//# sourceMappingURL=StackTraceRecover.web.mjs.map
